import { render, staticRenderFns } from "./EmployerDetails.vue?vue&type=template&id=0fd12741&scoped=true"
import script from "./EmployerDetails.vue?vue&type=script&lang=ts"
export * from "./EmployerDetails.vue?vue&type=script&lang=ts"
import style0 from "./EmployerDetails.vue?vue&type=style&index=0&id=0fd12741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd12741",
  null
  
)

export default component.exports